<vsf-modal [visible]="isOpen" (close)="closeModal()">
    <div class="p-6">
        <div
            class="flex justify-between items-center mb-6 border-b border-[#E5E8EC] pb-4"
        >
            <h3 class="text-[18px] text-[#000000] font-[600]">Contact Us</h3>
            <button
                (click)="closeModal()"
                class="text-gray-500 hover:text-gray-700"
            >
                <img
                    src="assets/icons/close-icon.svg"
                    alt="Close"
                    class="w-4 h-4"
                />
            </button>
        </div>

        <form
            [formGroup]="contactForm"
            (ngSubmit)="onSubmit()"
            class="flex flex-col gap-4"
        >
            <div class="flex flex-col gap-2">
                <label for="email" class="text-[14px] text-[#263238] font-[400]"
                    >Email (required)</label
                >
                <input
                    type="email"
                    id="email"
                    formControlName="email"
                    class="rounded-[18px] h-[38px] placeholder-[#999999] text-[12px] w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
                    [ngClass]="{
                        'border-red-500':
                            submitted && contactForm.get('email')?.errors
                    }"
                    placeholder="Enter your email"
                />
                <div
                    *ngIf="submitted && contactForm.get('email')?.errors"
                    class="text-red-500 text-xs"
                >
                    <div *ngIf="contactForm.get('email')?.errors?.['required']">
                        Email is required
                    </div>
                    <div *ngIf="contactForm.get('email')?.errors?.['email']">
                        Please enter a valid email
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <label
                    for="phoneNumber"
                    class="text-[14px] text-[#263238] font-[400]"
                    >Phone number (optional)</label
                >
                <input
                    type="tel"
                    id="phoneNumber"
                    formControlName="phoneNumber"
                    class="rounded-[18px] h-[38px] placeholder-[#999999] text-[12px] w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Enter your phone number"
                />
            </div>

            <div class="flex flex-col gap-2">
                <label
                    for="message"
                    class="text-[14px] text-[#263238] font-[400]"
                    >Message (required)</label
                >
                <textarea
                    id="message"
                    formControlName="message"
                    rows="4"
                    class="rounded-[18px] placeholder-[#999999] text-[12px] w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
                    [ngClass]="{
                        'border-red-500':
                            submitted && contactForm.get('message')?.errors
                    }"
                    placeholder="Enter your message"
                ></textarea>
                <div
                    *ngIf="submitted && contactForm.get('message')?.errors"
                    class="text-red-500 text-xs"
                >
                    <div
                        *ngIf="contactForm.get('message')?.errors?.['required']"
                    >
                        Message is required
                    </div>
                    <div
                        *ngIf="contactForm.get('message')?.errors?.['minlength']"
                    >
                        Message must be at least 10 characters
                    </div>
                </div>
            </div>

            <button
                type="submit"
                [disabled]="submitted"
                class="h-[38px] rounded-[6px] bg-brand-primary text-white px-4 py-2 rounded-md hover:bg-brand-primary-hover flex items-center justify-center disabled:bg-gray-300 disabled:cursor-not-allowed"
            >
                <span class="text-[12px] font-[600] text-white">Submit</span>
            </button>
        </form>
    </div>
</vsf-modal>
